/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BoardResponse as ApiBoardResponse } from '../models/api/board-response';
import { ListBoardsResponse as ApiListBoardsResponse } from '../models/api/list-boards-response';
import { copyBoard } from '../fn/boards/copy-board';
import { CopyBoard$Params } from '../fn/boards/copy-board';
import { createBoard } from '../fn/boards/create-board';
import { CreateBoard$Params } from '../fn/boards/create-board';
import { deleteBoard } from '../fn/boards/delete-board';
import { DeleteBoard$Params } from '../fn/boards/delete-board';
import { exportBoard } from '../fn/boards/export-board';
import { ExportBoard$Params } from '../fn/boards/export-board';
import { getBoard } from '../fn/boards/get-board';
import { GetBoard$Params } from '../fn/boards/get-board';
import { hardDeleteBoard } from '../fn/boards/hard-delete-board';
import { HardDeleteBoard$Params } from '../fn/boards/hard-delete-board';
import { listBoards } from '../fn/boards/list-boards';
import { ListBoards$Params } from '../fn/boards/list-boards';
import { spinUpBoard } from '../fn/boards/spin-up-board';
import { SpinUpBoard$Params } from '../fn/boards/spin-up-board';
import { updateBoard } from '../fn/boards/update-board';
import { UpdateBoard$Params } from '../fn/boards/update-board';

@Injectable({ providedIn: 'root' })
export class BoardsService extends BaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listBoards()` */
  static readonly ListBoardsPath = '/v1/boards';

  /**
   * List boards.
   *
   * List all boards
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listBoards()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBoards$Response(
    params?: ListBoards$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiListBoardsResponse>> {
    return listBoards(this.http, this.rootUrl, params, context);
  }

  /**
   * List boards.
   *
   * List all boards
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listBoards$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listBoards(params?: ListBoards$Params, context?: HttpContext): Observable<ApiListBoardsResponse> {
    return this.listBoards$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiListBoardsResponse>): ApiListBoardsResponse => r.body)
    );
  }

  /** Path part for operation `createBoard()` */
  static readonly CreateBoardPath = '/v1/boards';

  /**
   * Create board.
   *
   * Create a specific board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createBoard()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBoard$Response(
    params: CreateBoard$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<ApiBoardResponse>> {
    return createBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Create board.
   *
   * Create a specific board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createBoard$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createBoard(params: CreateBoard$Params, context?: HttpContext): Observable<ApiBoardResponse> {
    return this.createBoard$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiBoardResponse>): ApiBoardResponse => r.body)
    );
  }

  /** Path part for operation `spinUpBoard()` */
  static readonly SpinUpBoardPath = '/v1/boards/admin/spin-up';

  /**
   * Spin up a board.
   *
   * Spin up a new Board, runs copy operations towards Boards service as well
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `spinUpBoard()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  spinUpBoard$Response(params: SpinUpBoard$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return spinUpBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Spin up a board.
   *
   * Spin up a new Board, runs copy operations towards Boards service as well
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `spinUpBoard$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  spinUpBoard(params: SpinUpBoard$Params, context?: HttpContext): Observable<string> {
    return this.spinUpBoard$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `copyBoard()` */
  static readonly CopyBoardPath = '/v1/boards/{boardId}/copy';

  /**
   * Copy a board.
   *
   * Copy a specific Board, runs copy operations towards Boards service as well
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `copyBoard()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  copyBoard$Response(params: CopyBoard$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return copyBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Copy a board.
   *
   * Copy a specific Board, runs copy operations towards Boards service as well
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `copyBoard$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  copyBoard(params: CopyBoard$Params, context?: HttpContext): Observable<string> {
    return this.copyBoard$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `exportBoard()` */
  static readonly ExportBoardPath = '/v1/boards/{boardId}/export';

  /**
   * Export a board.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportBoard()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportBoard$Response(params: ExportBoard$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return exportBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Export a board.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportBoard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportBoard(params: ExportBoard$Params, context?: HttpContext): Observable<string> {
    return this.exportBoard$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `getBoard()` */
  static readonly GetBoardPath = '/v1/boards/{id}';

  /**
   * Get board.
   *
   * Get a specific board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBoard()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBoard$Response(params: GetBoard$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiBoardResponse>> {
    return getBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Get board.
   *
   * Get a specific board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBoard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBoard(params: GetBoard$Params, context?: HttpContext): Observable<ApiBoardResponse> {
    return this.getBoard$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiBoardResponse>): ApiBoardResponse => r.body)
    );
  }

  /** Path part for operation `deleteBoard()` */
  static readonly DeleteBoardPath = '/v1/boards/{id}';

  /**
   * Delete board.
   *
   * Delete a specific board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteBoard()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBoard$Response(params: DeleteBoard$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return deleteBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete board.
   *
   * Delete a specific board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteBoard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteBoard(params: DeleteBoard$Params, context?: HttpContext): Observable<string> {
    return this.deleteBoard$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `updateBoard()` */
  static readonly UpdateBoardPath = '/v1/boards/{id}';

  /**
   * Update board.
   *
   * Update a specific board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateBoard()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBoard$Response(params: UpdateBoard$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return updateBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Update board.
   *
   * Update a specific board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateBoard$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateBoard(params: UpdateBoard$Params, context?: HttpContext): Observable<string> {
    return this.updateBoard$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }

  /** Path part for operation `hardDeleteBoard()` */
  static readonly HardDeleteBoardPath = '/v1/boards/{id}/hard-delete';

  /**
   * Hard delete board.
   *
   * Hard delete a specific board
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `hardDeleteBoard()` instead.
   *
   * This method doesn't expect any request body.
   */
  hardDeleteBoard$Response(
    params: HardDeleteBoard$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    return hardDeleteBoard(this.http, this.rootUrl, params, context);
  }

  /**
   * Hard delete board.
   *
   * Hard delete a specific board
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `hardDeleteBoard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  hardDeleteBoard(params: HardDeleteBoard$Params, context?: HttpContext): Observable<string> {
    return this.hardDeleteBoard$Response(params, context).pipe(map((r: StrictHttpResponse<string>): string => r.body));
  }
}
